import React from "react"

import { LinkProps } from "shared/ui/link/Link"

import { ActiveProjectSelectModel } from "widgets/header/active-project-select/ActiveProjectSelect"

import { HeaderMenuButtonProps } from "./ui/HeaderMenuButton"
import { HeaderView } from "./ui/HeaderView"

export interface HeaderModel {
  logoLinkProps: LinkProps

  menuButtonProps: HeaderMenuButtonProps

  projectContextSelectModel: ActiveProjectSelectModel

  portalStage: string | null

  isAuthenticated: boolean

  openGlobalSearch: () => void
}

export const Header = React.memo(
  React.forwardRef(
    (props: HeaderModel, ref: React.ForwardedRef<HTMLDivElement>) => (
      <HeaderView ref={ref} {...props} />
    )
  )
)
